export enum FeatureFlagsOptions {
  FF_SAPRON_OLD_BANNER_SPOT = 'ff_sapron_old_banner_spot',
  FF_SAPRON_OWNER_DROPDOWN = 'ff_sapron_owner_dropdown',
  FF_SAPRON_BACKEND_ALLOW_DATA_EDIT = 'ff_sapron_backend_allow_data_edit',
  FF_MESSAGE_PRE_CHECKIN = 'ff_message_pre_checkin',
  FF_MESSAGE_CHECKIN = 'ff_message_checkin',
  FF_MESSAGE_PENDING_CHECKIN = 'ff_message_pending_checkin',
  FF_MESSAGE_SAME_DAY_PENDING_CHECKIN = 'ff_message_same_day_pending_checkin',
  FF_DISABLE_CHECKIN_CONTROLLER_V2 = 'ff_disable_checkin_controller_v2',
  FF_ENABLE_NEW_SECTION_FRANCHISE_FEE = 'ff_enable_new_section_franchise_fee',
  FF_ENABLE_FRANCHISE_NEW_DAMAGE_V2 = 'ff_enable_franchise_new_damage_v2',
  FF_ENABLE_WHATSAPP_DOCUMENTATION_SENT = 'ff_enable_whatsapp_documentation_sent',
  FF_COMP_RESERVATION_VIEW_MODE = 'ff_comp_reservation_view_mode',
  FF_ENABLE_ONBOARDING_PAYMENT_METHODS = 'ff_enable_onboarding_payment_methods',
  FF_ENABLE_POSTHOG_TRACKING_FOR_PARTNERS = 'ff_enable_posthog_tracking_for_partners',
  FF_CONCILIATION_WEBSITE_SEAZONE = 'ff_conciliation_website_seazone',
  FF_ENABLE_MARKETPLACE_FORM = 'ff_enable_marketplace_form',
  FF_ENABLE_NEW_INPUT_BUILDER_FORM = 'ff_enable_new_input_builder_form',
  FF_ENABLE_CREATE_PARTNER = 'ff_enable_create_partner',
  FF_ENABLE_BANNER_CARROSEL = 'ff_enable_banner_carrosel',
  FF_ENABLE_WHATSAPP_GROUP = 'ff_enable_whatsapp_group',
  FF_ENABLE_NEW_COMMISSION_TABLE = 'ff_enable_new_commission_table',
  FF_ENABLE_NEW_RESCUE_FORM = 'ff_enable_new_rescue_form',
  FF_ENABLE_RANKING_PARTNER = 'ff_enable_ranking_partner',
  FF_ENABLE_WEB_PUSH_NOTIFICATIONS = 'ff_enable_web_push_notifications',
  FF_MGO_LINK = 'ff_mgo_link',
  FF_SAPRON_ENABLE_OWNER_EDITION = 'ff_sapron_enable_owner_edition',
  FF_SAPRON_ENABLE_HOST_BANK_ACCOUNT_EDITION = 'ff_sapron_enable_host_bank_account_edition',
  FF_ENABLE_SPOT_SALES_MIRROR = 'ff_enable_spot_sales_mirror',
  FF_ENABLE_SPOT_ADJUSTMENTS = 'ff_enable_spot_adjustments',
  FF_ENABLE_HOST_HOME_BANNER = 'ff_enable_host_home_banner',
  FF_ENABLE_EDIT_OPERATIONAL_DETAILS = 'ff_enable_edit_operational_details',
  FF_ENABLE_HOT_OPPORTUNITIES = 'ff_enable_hot_opportunities',
  FF_ENABLE_COMISSION_PARTNER = 'ff_enable_comission_partner',
  FF_ENABLE_DOC_SELFIE_FIELD = 'ff_enable_doc_selfie_field',
  FF_ENABLE_GUESTWATCH = 'ff_enable_guestwatch',
  FF_ENABLE_FRANCHISE_FEE_MONTHLY_CAP = 'ff_enable_franchise_fee_monthly_cap',
  FF_ENABLE_SPOTMATCH_PARTNER = 'ff_enable_spotmatch_partner',
  FF_ENABLE_NEW_LANCAMENTOS = 'ff_enable_new_lancamentos',
  FF_CENTRAL_ATIVIDADES_SPN = 'ff_central_atividades_spn',
  FF_REDIRECT_HOST_TO_FRANQUIAS = 'ff_redirect_host_to_franquias',
  FF_SAPRON_BACKEND_ENABLE_INSURANCE_AUTOMATION = 'ff_sapron_backend_enable_insurance_automation',
  FF_ENABLE_REVENDAS_PARTNER = 'ff_enable_revendas_partner',
  // ON = esconde os campos "apoio de vendas" no detalhe de Revendas
  // (Sobre o Empreendimento, Atualizações da Obra, Rendimento Médio Líquido,
  // Plantas, marcos extras, ACS). Enquanto o dado no spotsys não está maduro,
  // mantém a paridade com a lovable escondida.
  FF_HIDE_REVENDAS_APOIO_VENDAS = 'ff_hide_revendas_apoio_vendas',
  // ON = esconde SÓ a seção Decor da revenda (parte mais complexa; pode não
  // estar pronta em prod). Controlável via PostHog (kill switch independente).
  FF_HIDE_REVENDAS_DECOR = 'ff_hide_revendas_decor',
  // ON = as seções de obra do detalhe de parceiros (Cronograma de Obras,
  // Atualizações da Obra, Datas dos Marcos, Alvarás, Destaques, Avanço físico)
  // vêm do campo `informative` do detalhe (endpoint `partner-informative` do
  // api-spotsys, mês publicado) via o componente `InformativoObra`, e a página
  // para de ler os campos digitados à mão (`construction_completion_pct`,
  // `approval_percentage`, `construction_*_date_informative`). OFF = página
  // como antes. Gate de virada do PRD-informativos-spotsys (seção 10).
  FF_PARTNERS_INFORMATIVO_SPOTSYS = 'ff_partners_informativo_spotsys',
  FF_MANUTENCAO = 'ff_manutencao',
  // ON = abre a aba "Agentes de IA" da Central de Manutenção para Seazoner,
  // que por padrão é só Admin. Mesma string que o backend lê em
  // `IsAgentsMonitorReader`, de propósito: UMA flag no PostHog cobre a aba e a
  // rota. Chaves diferentes fariam a aba aparecer para quem a API recusa.
  // Existe porque `roles` é por banco: quem é Admin em produção pode não ser
  // no banco de staging, e aí o monitor fica inalcançável no ambiente em que o
  // agente é validado. Criada só no projeto de staging do PostHog.
  FF_MANUTENCAO_AGENTES_SEAZONER = 'ff_manutencao_agentes_seazoner',
  FF_CHANNEL_MANAGER_ENABLED = 'ff_channel_manager_enabled',
  FF_SAPRON_BACKEND_ENABLE_ATTENDANT_HOST_PASSWORD_RESET = 'ff_sapron_backend_enable_attendant_host_password_reset',
  // ON = habilita a jornada unificada do parceiro (SZI): montagem do fluxo de
  // pagamento na indicação quente + acompanhamento das 6 etapas. Gate do piloto.
  FF_ENABLE_PARTNER_PAYMENT_FLOW = 'ff_enable_partner_payment_flow',
  // ON = jornada digital de locação SZS na wallet: landing, wizard, lista com esteira e detalhe.
  FF_SZS_JORNADA_UNIFICADA_ENABLED = 'ff_szs_jornada_unificada_enabled',
  // ON = card "Grandes Operações (Mais de 15 unidades)" no painel: indicação pura de locação
  // marcada como grande operação, que nunca cai em reunião coletiva. Só aparece com a jornada
  // SZS ligada. Sem a flag no PostHog ela fica desligada; ligar é decisão do Luiz.
  FF_WALLET_GRANDES_OPERACOES = 'ff_wallet_grandes_operacoes',
  // ON = porta Indicar × Fechar no tipo Parceiro: o parceiro pode mandar ele
  // mesmo o convite de cadastro (link) para quem indicou e acompanhar a trilha.
  // Mesma chave que o sapron-backend lê para aceitar `journey_intent=invite`.
  FF_PARCEIRO_FECHAR = 'ff_parceiro_fechar',
  // A ÚNICA sub-flag que sobrou, e ela governa UMA coisa só: o espelho de
  // vendas é a tela nativa do Sapron ou o `<iframe>` do Spotômetro.
  //
  // Em conjunção com FF_ENABLE_PARTNER_PAYMENT_FLOW, e só com ela: o espelho
  // nativo entrega a unidade ao formulário da jornada, então sem a jornada ele
  // não tem para onde levar. Ligada + jornada ligada = tela nativa; qualquer
  // outra combinação = iframe.
  //
  // Existe separada porque o iframe é o ÚNICO revert que não é uma release: o
  // Spotômetro continua no ar, e desligar esta chave devolve exatamente a tela
  // de hoje sem deploy. As telas mobile do formulário (etapa 1 e 2), que antes
  // dividiam a sub-flag com o espelho, passaram a seguir a jornada.
  //
  // NÃO confundir com FF_ENABLE_SPOT_SALES_MIRROR, que dá ACESSO à rota: sem
  // aquela o parceiro nem chega nesta tela, seja qual for o valor desta.
  FF_ENABLE_ESPELHO_NATIVO = 'ff_enable_espelho_nativo',
  // ON = as rotas de indicar e de acompanhar indicações do parceiro levam à
  // tela equivalente do App Seazone (tabela em `RedirecionaParaHostzone`).
  // Desligada por padrão; desligar é o kill-switch, sem deploy. Só o PostHog
  // decide: sem override por env, que ganharia dele.
  FF_REDIRECT_HOSTZONE_INDICACOES = 'ff_redirect_hostzone_indicacoes',
  // ON = Ganhos (`/parceiros/ganhos`) e Resgatar (`/parceiros/resgate`) do
  // parceiro levam ao Meu saldo do App Seazone (`/saques` e `/saques/sacar`;
  // tabela em `RedirecionaParaHostzone`). Separada da de indicações de
  // propósito: são telas e upstreams diferentes, e cada uma é o kill-switch da
  // sua superfície (desligar devolve só o saldo ao Sapron, sem deploy).
  // Desligada por padrão; quem liga, em stg e em prd, é o Thomaz. Só o PostHog
  // decide: sem override por env, que ganharia dele.
  FF_REDIRECT_HOSTZONE_SALDO = 'ff_redirect_hostzone_saldo',
  // ON = o "Ticket Médio" da Ficha Técnica do detalhe de revenda e de
  // lançamento (parceiros) mostra o revisado com as chamadas de capital
  // (`revised_capital_call_average_ticket`) quando ele existe; senão, o de
  // lançamento. OFF = só o de lançamento, como antes. Só o PostHog decide: sem
  // override por env. As páginas são públicas: o visitante é anônimo, então a
  // liberação não pode depender de propriedade de pessoa.
  FF_PARTNERS_TICKET_MEDIO_COM_CHAMADAS = 'ff_partners_ticket_medio_com_chamadas',
}
